export function formatMilliseconds(ms) {
  if (ms === null || ms === undefined || isNaN(ms)) {
    return "-";
  } else if (ms < 1000) {
    return `${Math.round(ms)}ms`;
  } else if (ms < 60000) {
    return `${(ms / 1000).toFixed(1)}s`;
  } else if (ms < 3600000) {
    return `${Math.round(ms / 60000)}m`;
  } else if (ms >= 1000000000000000000) {
    return "+Inf";
  } else {
    return `${Math.round(ms / 3600000)}h`;
  }
}

export function formatMicroseconds(ms) {
  return formatMilliseconds(ms / 1000);
}

export function formatMillisecondsLong(ms) {
  let seconds = Math.round(ms / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let remainderMinutes = minutes % 60;

  let formattedTime = "";
  if (hours > 0) {
    formattedTime += `${hours}h `;
  }
  if (remainderMinutes > 0) {
    formattedTime += `${remainderMinutes}m `;
  }
  formattedTime += `${seconds % 60}s`;

  return formattedTime;
}

export function formatMicrosecondsLong(ms) {
  return formatMillisecondsLong(ms / 1000);
}

export function formatShort(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(2) + "K";
  } else if (num > 1000000 && num < 1000000000) {
    return (num / 1000000).toFixed(2) + "M";
  } else if (num > 1000000000) {
    return (num / 1000000000).toFixed(2) + "B";
  } else if (num < 1000) {
    return num;
  }
}

export function roundToDecimalPlace(num, places) {
  const scale = Math.pow(10, places);
  return Math.round(num * scale) / scale;
}
